/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1MylibraryPeople200,
  GetApiV1MylibraryPeople400,
  GetApiV1MylibraryPeople401,
  GetApiV1MylibraryPeople500,
  GetApiV1MylibraryPeopleQueryParams,
  GetApiV1MylibraryPeopleQueryResponse,
} from "../../types/myLibraryPessoasController/GetApiV1MylibraryPeople.ts";
import { myLibraryPersonViewModelPaginatedResponseSchema } from "../myLibraryPersonViewModelPaginatedResponseSchema.ts";

export const getApiV1MylibraryPeopleQueryParamsSchema = z.object({
  Email: z.optional(
    z
      .string()
      .describe(
        "E-mails a filtrar, separados por vírgula. A comparação ignora maiúsculas, minúsculas e espaços em volta. Opcional.",
      ),
  ),
  Page: z.coerce
    .number()
    .int()
    .default(1)
    .describe("Página desejada, começando em 1."),
  PageSize: z.coerce
    .number()
    .int()
    .default(25)
    .describe("Quantidade de registros por página, entre 1 e 500."),
}) as unknown as ToZod<GetApiV1MylibraryPeopleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1MylibraryPeople200Schema = z.lazy(
  () => myLibraryPersonViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1MylibraryPeople200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1MylibraryPeople400Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryPeople400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1MylibraryPeople401Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1MylibraryPeople500Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryPeople500>;

export const getApiV1MylibraryPeopleQueryResponseSchema = z.lazy(
  () => getApiV1MylibraryPeople200Schema,
) as unknown as ToZod<GetApiV1MylibraryPeopleQueryResponse>;
